import React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const ApparentGenderCheckboxesPopover = ({ onCountChange, ...props }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const selectedApparentGender = useWatch({ name: 'apparent_gender' });
  const filterCount = selectedApparentGender ? 1 : 0;
  useFilterCount('apparent_gender', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="apparentGenderFilter"
      triggerValue={t('events:body basic attributes.apparent gender')}
      {...props}
    >
      <CheckboxCustomFilter
        control={control}
        name="apparent_gender"
        options={EVENT_ENUMS.BODY_BASIC_ATTRIBUTES.APPARENT_GENDER.raw}
      />
    </CustomFilterPopover>
  );
};
